/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssistantConversationPermissionsParser = 
/* #__PURE__ */ parsers.object([
    ['view', codecBoolean],
    ['viewAuthor', codecBoolean, 'view_author'],
    ['create', codecBoolean],
    ['useTools', codecBoolean, 'use_tools'],
]);
export class AssistantConversationPermissions extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssistantConversationPermissionsParser.decode(input).map(res => new AssistantConversationPermissions(res));
    }
    static unsafeDecode(input) {
        return AssistantConversationPermissions.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssistantConversationPermissionsParser.encode(data);
    }
    static schema() {
        return AssistantConversationPermissionsParser.schema();
    }
}
